import { link } from 'fs';
import { IRouteItem } from '../router.d';

export interface IRouteList {
  [x: string]: any;
  // react: IRouteItem;
  // HomeVoting: IRouteItem;

}

const Digitalcertificates = '/e-digitalcert';
const DigitalMedicalCert ='/e-medicalcert';
const Signature ='/signature';
const DocumentPersonal ='/document-personal';
const SelectPersonalData ='/document-personal-type';
const IndexDocumentPer ='/document-signature';
const IndexDocumentPending ='/document-pending';
const FormPersonalData ='/form-personal';
const FormPersonalNew ='/form-personal-new';
const GuestDocument ='/guest-document-personal';
const SharedToken ='/redirect_provider';
const MainPendingDocument = '/pending-document';
// const MainDetailPending = 'document-signature-pending';
const DetailPersonalAgree = '/detail-personal-document';

const PageAdminDoc = '/admin-page-document';
const PagePublicHealth = '/public-health';


const MainError = '/error';
const pagenotfound = '/404'


const Route: IRouteList = {
  Digitalcertificates: {
    link: `${Digitalcertificates}`,
    name: 'Digitalcertificates',
  },
  DigitalMedicalCert: {
    link: `${DigitalMedicalCert}`,
    name: 'DigitalMedicalCert',
  },
  Signature: {
    link: `${Signature}`,
    name: 'Signature',
  },
  PageAdminDoc: {
    link: `${PageAdminDoc}`,
    name: 'PageAdminDoc',
  },
  PagePublicHealth: {
    link: `${PagePublicHealth}`,
    name: 'PagePublicHealth',
  },

  
  DocumentPersonal:{
    link: `${DocumentPersonal}`,
    name: 'DocumentPersonal',
  },
  SelectPersonalData: {
    link: `${SelectPersonalData}`,
    name: 'SelectPersonalData',
  },
  IndexDocumentPer: {
    link: `${IndexDocumentPer}`,
    name: 'IndexDocumentPer',
  },
  FormPersonal: {
    link: `${FormPersonalData}`,
    name: 'FormPersonal',
  },
  FormPersonalNew: {
    link: `${FormPersonalNew}`,
    name: 'FormPersonalNew',
  },
  GuestDocument: {
    link: `${GuestDocument}`,
    name: 'GuestDocument',
  },
  SharedToken: {
    link: `${SharedToken}`,
    name: 'SharedToken',
  },
  MainPendingDocument: {
    link: `${MainPendingDocument}`,
    name: 'MainPendingDocument',
  },
  IndexDocumentPending: {
    link: `${IndexDocumentPending}`,
    name: 'IndexDocumentPending',
  },
  DetailPersonalAgree: {
    link: `${DetailPersonalAgree}`,
    name: 'DetailPersonalAgree',
  },
  MainError: {
    link: `${MainError}`,
    name: 'MainError',
  },
  PageNotfound: {
    link: `${pagenotfound}`,
    name: 'PageNotfound',
  },
  

};

export default Route;
